import { FC } from 'react';
import MuiSvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from './SvgIcon.interface';

const sizeMap = {
  small: {
    width: 16,
    height: 16,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 48,
    height: 48,
  },
};

export const SvgIcon: FC<SvgIconProps> = ({ size = 'medium', children, ...props }) => {
  const { width, height } = sizeMap[size];

  return (
    <MuiSvgIcon
      width={width}
      height={height}
      fill={'none'}
      fontSize={size}
      {...props}
      sx={{
        width: 'unset',
        height: 'unset',
      }}
    >
      {children}
    </MuiSvgIcon>
  );
};
